import React, { useEffect, useState } from "react";
import client from "../../utils/prismicHelpers";
import * as queries from "../../utils/prismicQueries";
import Header from "../../main/components/header";
import "./frontline.css";
import { Helmet } from "react-helmet";
import HealthCard from "../../main/components/HealthCard/HealthCard";
import BackBtn from "../../main/components/BackBtn";
import { useLocation } from "react-router-dom";
import VignetteBtn from "../../main/components/VignetteBtn/VignetteBtn";
import HealthTopCrd from "../health/HealthTopCrd/HealthTopCrd";

const Frontline = () => {
  const [healthInfo, setHealthDoc] = useState(null);
  const location = useLocation();
  useEffect(() => {
    client
      .query({
        query: queries.reimagineHealth2,
      })
      .then((response) => {
        const healthInfo = response.data.allHealths.edges[0].node;
        setHealthDoc(healthInfo);
      })
      .catch((error) => {
        console.error(error);
      });
  });
  window.scrollTo(0, 0);
  return (
    <>
   
      <section className=" pb-0 section-common-info">
        <div className="container">
          <div className="  d-flex flex-column-reverse  flex-md-row  pb-2 justify-content-between">
            <div className="w-75 health-header">
              <BackBtn text={"Reimagine Health"} link={"/reimagine-health"} />
              <p className=" fw-bold pb-0 px-md-1  health-fst-text">
                {healthInfo?.subtitle}
              </p>
              <h3 className="subtitle  pt-0 ">{healthInfo?.title}</h3>
              <div className=" health-description">
                <p> {healthInfo?.des1}</p>
                <p> {healthInfo?.des2}</p>
                <p> {healthInfo?.des3}</p>
              </div>
            </div>
            <div className="d-none d-lg-block">
              <HealthTopCrd ifHealthCrd={true} />
            </div>
          </div>
          <VignetteBtn />
          <div className="row py-2 g-2">
            {healthInfo?.health_slider?.map((healthInfo, index) => (
              <HealthCard cardInfo={healthInfo} key={index + 1}></HealthCard>
            ))}
          </div>

          <div className="health-contact mb-5">
            <div className="pt-5">
              <h3>{healthInfo?.card2Des1}</h3>
              <a
                target="_blank"
                className="text-decoration-none  "
                href={"mailto:" + healthInfo?.card2_email}
              >
                <h3>{healthInfo?.card2_email}</h3>
              </a>
            </div>
          </div>
          <VignetteBtn />
          <div className="d-block d-md-none">
            <HealthTopCrd ifHealthCrd={true} />
          </div>
        </div>
      </section>
     
    </>
  );
};

export default Frontline;
